import { ImgHTMLAttributes, useRef, useState } from 'react';

import { cn } from '@/services/utils';

import { Loader } from '../Loader';

const Image = ({ className, ...props }: ImgHTMLAttributes<HTMLImageElement> ) => {

    const ref = useRef<HTMLImageElement>(null);
    const [loading, setLoading] = useState(true);

    const onLoad = () => {
        if (ref.current) {
            setLoading(false);

            // Allow a smooth transition when we have the image
            ref.current.style.display = 'block';
            setTimeout(() => {
                if(ref.current) {
                    ref.current.style.opacity = '1';
                }
            }, 300);
        }
    };

    const onError = () => {
        if (ref.current) {
            setLoading(false);
            ref.current.style.display = 'none';
        }
    };

    return (
        <>
            {loading && <Loader />}
            <img
                className={cn('tw-transition-opacity tw-duration-500 tw-opacity-0 tw-hidden', className)}
                ref={ref}
                onLoad={onLoad}
                onError={onError}
                {...props}
            />
        </>
    );

};

export { Image };
